import { useQuery } from "@apollo/client";
import { CenterResult } from "__legacy/components/CenterResult";
import { CenterSpinner } from "__legacy/components/CenterSpinner";
import { loader } from "graphql.macro";
import { Fragment, ReactElement, ReactNode } from "react";

import { StakeholderQuery as StakeholderQueryType, StakeholderQueryVariables } from "./__generated__/StakeholderQuery";

const StakeholderQuery = loader("./StakeholderQuery.gql");

type StakeholderQueryProviderType = (props: {
  children: (data: StakeholderQueryType) => ReactNode;
  variables: StakeholderQueryVariables;
}) => ReactElement;

export const StakeholderQueryProvider: StakeholderQueryProviderType = (props) => {
  const { children, variables } = props;

  const { error, loading, data } = useQuery<StakeholderQueryType, StakeholderQueryVariables>(StakeholderQuery, {
    variables,
    fetchPolicy: "cache-and-network",
  });

  if (loading) return <CenterSpinner size="large" />;
  if (error || !data)
    return <CenterResult status="404" title="404" subTitle="Sorry, the page you visited does not exist." />;

  return <Fragment>{children(data)}</Fragment>;
};
